module.exports = __webpack_public_path__ + "69a862e51868e21502fa05828b73fed0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/night-sky.png
// module id = 2400
// module chunks = 0